module.exports = __webpack_public_path__ + "img/flask.ec179819.png";